import { useEffect } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import HowItWorks from "@/components/site/HowItWorks";
import WhyUs from "@/components/site/WhyUs";
import QuoteForm from "@/components/site/QuoteForm";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useEffect(() => {
    document.title =
      "El Monos — Landscaping, Lawn Care & Junk Removal · San Antonio";
  }, []);

  return (
    <main
      data-testid="landing-page"
      className="bg-[#FFFFFF] text-[#111613] overflow-x-hidden"
    >
      <Header />
      <Hero />
      <TrustStrip />
      <Services />
      <Marquee variant="light" />
      <Gallery />
      <HowItWorks />
      <WhyUs />
      <Marquee variant="dark" />
      <QuoteForm />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
